import React from "react";
import styles from "./DiagnosticReport.module.css";
import {
  DIAGNOSTIC,
  DIAGNOSTIC_FEATURES,
  DIAGNOSTIC_REPORT_URL,
} from "../assets";
import Lines from "../Lines";

export default function DiagnosticReport({ onBookDemo }) {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.inner}>
          <div className={styles.left}>
            {/* Wrapped so the mobile layout can flow the two as a single
                paragraph (Figma 12233:2063) while desktop keeps them stacked. */}
            <div className={styles.headings}>
              <p className={styles.kicker}>Get Your Factory’s</p>
              <h2 className={styles.title}>
                Diagnostic Report worth ₹1 Lakh in 7 Days!
              </h2>
            </div>

            <ul className={styles.features}>
              {DIAGNOSTIC_FEATURES.map((feature) => (
                <li key={feature.id} className={styles.feature}>
                  <img
                    src={feature.icon}
                    alt=""
                    className={styles.featureIcon}
                    width={40}
                    height={40}
                    loading="lazy"
                  />
                  {/* Mobile wraps these in a 4px-gap text frame; desktop has
                      them as direct children on the pill's own 12px gap, which
                      `display: contents` preserves. */}
                  <div className={styles.featureText}>
                    <p className={styles.featureTitle}>
                      <Lines value={feature.title} />
                    </p>
                    <p className={styles.featureBody}>{feature.body}</p>
                  </div>
                </li>
              ))}
            </ul>

            <button type="button" className={styles.cta} onClick={onBookDemo}>
              Book Your Diagnostic Today
            </button>
          </div>

          <div className={styles.right}>
            <img
              src={DIAGNOSTIC.laptop}
              alt="The MetalCloud melting overview dashboard shown on a laptop"
              className={styles.laptop}
              width={814}
              height={509}
              loading="lazy"
            />
            {/* Collapsed to an icon tile; expands leftward to reveal the
                label on hover or keyboard focus, anchored on its right edge
                exactly as the two Figma states are. */}
            <a
              className={styles.badge}
              href={DIAGNOSTIC_REPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.badgeInner}>
                <span className={styles.badgeLabel}>See Full Report</span>
                <img
                  src={DIAGNOSTIC.folderChart}
                  alt=""
                  className={styles.badgeIcon}
                  width={24}
                  height={24}
                />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
